export enum EArtistVideoType {
    YOUTUBE = 'youtube',
    CUSTOM_VIDEO = 'custom',
    GIF = 'gif'
}
